import React from 'react';
import {I18nUtils} from "../../../../../i18n/I18nUtils";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import * as messageDetailActions from "../shared/actions/messageDetailActions";
import PropTypes from 'prop-types';

class ResponseMessageDetail extends React.Component {

  constructor(props){
    super(props);

    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      messageToSend: '',
    }
  }

  onSubmit(event){
    event.preventDefault();
    this.props.messageDetailActions.responseMessage(this.props.messageId, this.state.messageToSend, () => {
      this.setState({ messageToSend: '' });
    });
  }

  render() {
    return (
      <section className="write-message">
        <form onSubmit={this.onSubmit}>
          <div className="form-group">
            <div className="form-line">
              <label htmlFor="write" className="">{I18nUtils.tr('TR_ESCRIBIR_MENSAJE')}</label>
              <textarea
                rows="1"
                name="address"
                id="write"
                className="form-control no-resize auto-growth"
                value={this.state.messageToSend}
                onChange={(event) => this.setState({ messageToSend: event.target.value})}
              > </textarea>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 pull-right">
              <div className="form-group">
                <button type="submit" className="btn btn-default btn-block btn-sm waves-effect">{I18nUtils.tr('TR_ENVIAR')}</button>
              </div>
            </div>
          </div>
        </form>
      </section>
    );
  }

}


const mapStateToProps = state => {
  return({
  });
};

const mapDispatchToProps = dispatch => ({
  messageDetailActions: bindActionCreators(messageDetailActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResponseMessageDetail);


ResponseMessageDetail.propTypes = {
  messageId: PropTypes.string.isRequired,
};

ResponseMessageDetail.defaultProps = {
};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/to-refactor/detail/ResponseMessageDetail.js